import goalsApi from "../../api/placements/goals";

export default {
  namespaced: true,

  state: {
    goals: [],
    goal: {}
  },

  mutations: {
    SET_GOALS(state, payload) {
      state.goals = payload;
    },
    SET_GOAL(state, payload) {
      state.goal = payload;
    }
  },

  actions: {
    getForStudentOpportunity(context, studentOpportunityId) {
      return new Promise((resolve, reject) => {
        goalsApi
          .getForStudentOpportunity(studentOpportunityId)
          .then(function(response) {
            context.commit("SET_GOALS", response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    getGoal(context, goalId) {
      return new Promise((resolve, reject) => {
        goalsApi
          .get(goalId)
          .then(function(response) {
            context.commit("SET_GOAL", response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    createGoal(context, goal) {
      return new Promise((resolve, reject) => {
        goalsApi
          .postCreate(goal)
          .then(function(response) {
            context.commit("SET_GOALS", response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    createGoals(context, goals) {
      return new Promise((resolve, reject) => {
        goalsApi
          .postCreateAll(goals)
          .then(function(response) {
            context.commit("SET_GOALS", response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    emptyGoals(context) {
      return new Promise((resolve, reject) => {
        context.commit("SET_GOALS", []);
        resolve();
      });
    }
  }
};
